import { api, useApi } from '@gik/core/api';

export interface IGetGoFundMeCampaignPageStatusResponse {
  valid: boolean;
}

export function usePageGoFundMeCampaignValid(inkindRouteId: string) {
  return useApi<IGetGoFundMeCampaignPageStatusResponse>(
    inkindRouteId ? `inkinds/${inkindRouteId}/gofundme-campaign-status` : null
  );
}

export async function isGoFundMeCampaignValid(campaignSlug: string): Promise<IGetGoFundMeCampaignPageStatusResponse> {
  if (campaignSlug) {
    const response = await api.get(`gofundme/campaign-status?campaignSlug=${campaignSlug}`);
    return response.json();
  } else {
    return Promise.resolve({
      valid: false,
    });
  }
}
